export default __webpack_public_path__ + "static/media/Location.dd88cac1.xlsx";